import React from 'react';
import { ATextInteractive } from '../../atoms/ATextInteractive/index';
import { ATextInteractiveSize } from '../../atoms/ATextInteractive/ATextInteractive.types';
import { AIcon } from '../../atoms/AIcon/index';
import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import * as Styled from './MBreadcrumb.styles';
import { MBreadcrumbProps } from './MBreadcrumb.types';

export const MBreadcrumb: React.FC<MBreadcrumbProps> = ({ aTextInteractive, isLast }) => {
  return (
    <Styled.Wrapper>
      <ATextInteractive {...aTextInteractive} size={ATextInteractiveSize.XS} />
      {!isLast && <AIcon icon="icon-arrow-right" size={AIconSize.S} />}
    </Styled.Wrapper>
  );
};
